import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue')
  },
  {
    path: '/editor/:id?/:orderId?',
    name: 'Editor',
    component: () => import(/* webpackChunkName: "editor" */ '../views/Editor.vue')
  },
  {
    path: '/projects/:id?/:orderId?',
    name: 'Projekty',
    component: () => import(/* webpackChunkName: "editor" */ '../views/Projects.vue')
  },
  {
    path: '/assign/:orderId',
    name: 'Assign',
    component: () => import(/* webpackChunkName: "editor" */ '../views/Assign.vue')
  },
  {
    path: '*',
    name: 'catchAll',
    component: Home
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const restrictedPages = ['/editor'];
  const authRequired = restrictedPages.includes(to.path);
  const loggedIn = localStorage.getItem('user');

  if (authRequired && !loggedIn) {
    return next('/login');
  }

  next();
})

export default router
